/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeckDTO
 */
export interface DeckDTO {
    /**
     * 
     * @type {string}
     * @memberof DeckDTO
     */
    creatorId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeckDTO
     */
    editorIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeckDTO
     */
    viewerIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DeckDTO
     */
    ownerId?: string;
    /**
     * 
     * @type {string}
     * @memberof DeckDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DeckDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DeckDTO
     */
    creatorName: string;
    /**
     * 
     * @type {string}
     * @memberof DeckDTO
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof DeckDTO
     */
    imageId?: string;
    /**
     * 
     * @type {number}
     * @memberof DeckDTO
     */
    deckImageNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof DeckDTO
     */
    modificationTimestamp: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeckDTO
     */
    cardBackImageIds?: Array<string>;
}

/**
 * Check if a given object implements the DeckDTO interface.
 */
export function instanceOfDeckDTO(value: object): value is DeckDTO {
    if (!('creatorId' in value) || value['creatorId'] === undefined) return false;
    if (!('editorIds' in value) || value['editorIds'] === undefined) return false;
    if (!('viewerIds' in value) || value['viewerIds'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('creatorName' in value) || value['creatorName'] === undefined) return false;
    if (!('modificationTimestamp' in value) || value['modificationTimestamp'] === undefined) return false;
    return true;
}

export function DeckDTOFromJSON(json: any): DeckDTO {
    return DeckDTOFromJSONTyped(json, false);
}

export function DeckDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeckDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'creatorId': json['creatorId'],
        'editorIds': json['editorIds'],
        'viewerIds': json['viewerIds'],
        'ownerId': json['ownerId'] == null ? undefined : json['ownerId'],
        'id': json['id'],
        'name': json['name'],
        'creatorName': json['creatorName'],
        'description': json['description'] == null ? undefined : json['description'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'deckImageNumber': json['deckImageNumber'] == null ? undefined : json['deckImageNumber'],
        'modificationTimestamp': json['modificationTimestamp'],
        'cardBackImageIds': json['cardBackImageIds'] == null ? undefined : json['cardBackImageIds'],
    };
}

export function DeckDTOToJSON(json: any): DeckDTO {
    return DeckDTOToJSONTyped(json, false);
}

export function DeckDTOToJSONTyped(value?: DeckDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'creatorId': value['creatorId'],
        'editorIds': value['editorIds'],
        'viewerIds': value['viewerIds'],
        'ownerId': value['ownerId'],
        'id': value['id'],
        'name': value['name'],
        'creatorName': value['creatorName'],
        'description': value['description'],
        'imageId': value['imageId'],
        'deckImageNumber': value['deckImageNumber'],
        'modificationTimestamp': value['modificationTimestamp'],
        'cardBackImageIds': value['cardBackImageIds'],
    };
}

